export default {
  attributes: {},
  icon: null,
  name: 'STACK',
  title: 'Stack',
  v: 0,
};
